import CityRepository from '@/business/modules/city/city.repository';
import type { ICityResponse } from '@/business/modules/city/city.model';

class CityService {
	static #instance: CityService;
	private readonly repository;

	private constructor() {
		this.repository = CityRepository.getInstance();
	}

	public static getInstance(): CityService {
		if (!CityService.#instance) {
			CityService.#instance = new CityService();
		}

		return CityService.#instance;
	}

	getCities(): Promise<ICityResponse[]> {
		return this.repository.getCities();
	}
}

export default CityService;
